<div class="modal-header d-flex justify-content-center bg-light">
    <h4 class="modal-title text-center">Confirm bid<div class="modalsubheader">{{'tenders.confirmBid'|cxTranslate}}
        </div>
    </h4>
</div>
<div *ngIf="enableLoader" id="loader"></div>
<div *ngIf="!enableLoader">
    <div class="modal-body bg-light">
        <div *ngFor="let data of productInfo;let i=index">
            <div class="small text-secondary">{{ 'home.headerLinks.material' | cxTranslate }} #{{i+1}}</div>
            <div>
                <h5 class="strong">{{data?.newName?data.newName:data.productName}}</h5>
            </div>
            <div class="d-flex justify-content-between mt-2">
                <div class="small">
                    <div class="small text-secondary">{{ 'tenders.Quantity(DMT)' | cxTranslate
                        }}({{data.displayQuantityUnitDesc}})</div>
                    <div class="strong small">{{data?.quantityshw | number}}</div>
                </div>
                <div class="small">
                    <div class="small text-secondary wrap">{{'tenders.Deliveryperiod'| cxTranslate}}</div>
                    <div class="strong small">{{data?.laycanStartDate | date:"dd/MM/yyyy"}} -
                        {{data?.laycanEndDate | date:"dd/MM/yyyy"}}</div>
                </div>
            </div>
            <div class="d-flex justify-content-between mt-2">
                <div class="small">
                    <div *ngIf="data.baseKOP == 'BA CU'" class="small text-secondary">{{'tenders.QuotationPeriodCU'|
                        cxTranslate}} </div>
                    <div *ngIf="data.baseKOP == 'BA ZN'" class="small text-secondary">{{'tenders.QuotationPeriodZN'|
                        cxTranslate}}</div>
                    <div *ngIf="data.baseKOP != 'BA CU' && data.baseKOP != 'BA ZN'" class="small text-secondary">
                        {{'tenders.QuotationPeriod'| cxTranslate}}</div>
                        <div *ngIf="data.isQuotationPeriodUnrestricted == false && data.isQPMultipleChoicesSelected == false" class="small">{{formatQPDates(data)}}
                        </div>
                        <div *ngIf=" data.isQPMultipleChoicesSelected == true" class="small">
                           <!-- {{data.pricingOptionsEnum[0] | json}} -->
                            <p *ngIf="data.pricingOptionsEnum[0]?.qp[0].description != 'Fixed QP'">{{ data.pricingOptionsEnum[0]?.qp[0].description}}</p>
                            <p *ngIf="data.pricingOptionsEnum[0]?.qp[0].description == 'Fixed QP'">{{getDate(finalQPFromDate)}} - {{getDate(finalQPToDate)}} (both dates inclusive)</p>
                        </div>
                        <!-- <div *ngIf="data.pricingOptionsEnum[0].isQPMultipleChoicesSelected == true" class="small">
                            {{data.pricingOptionsEnum[0].qp[0].description}}</div> -->
                        <div *ngIf="data.pricingOptionsEnum[0]?.isQPMultipleChoicesSelected == false && data.isQuotationPeriodUnrestricted==true" class="small">{{getDate(data?.finalQPFromDate)}} -
                            {{getDate(data?.finalQPToDate)}} (both dates inclusive)</div>
                </div>
            </div>
            <div>
                <div class="small text-secondary mt-2">{{'tenders.TermsAndconditions'|cxTranslate}}</div>
                <div class="small">{{multipleProduct.termsAndConditions?multipleProduct.termsAndConditions.description:'--'}} </div>
            </div>
            <div class="d-flex justify-content-between mt-2">
                <div class="small">
                    <div class="small text-secondary price-wrap">Your TC (per
                        {{data.displayTCPriceConfig.displayTCPriceUnitDesc}})</div>
                    <div class="strong small">USD {{data?.tcPrice.value}}</div>
                </div>
                <div class="small" *ngIf="data.displayRCPriceConfig.displayRCPrice == true">
                    <div class="small text-secondary wrap">Your RC (per
                        {{data.displayRCPriceConfig.displayRCPriceUnitDesc}} of payable Copper)</div>
                    <div class="strong small">USD {{data?.rcPrice.value}}</div>
                </div>
            </div>
           
            
            <hr>
        </div>
        <div class="mt-4" *ngIf="multipleProduct.commodityType!= 'IO'">
            <p class="mb-2 xs-semibold-font">{{'tenders.BuyerRemarks'|cxTranslate}}</p>
            <textarea class="form-control w-100 border" maxlength="5000"
                placeholder="{{ 'home.productHeader.bindingTermsPh' | cxTranslate }}"
                [(ngModel)]="additionalTerms"></textarea>
        </div>
    </div>

    <div class="modal-footer bg-light">
        <div class="w-100 text-center">
            <p class="mb-2 xs-semibold-font">{{confirmTxt}}</p>
        </div>
        <div class="w-100">
            <!-- <button class="btn btn-block btn-primary" type="submit" (click)="navigateToQuote(productInfo,quantitySelected)" data-dismiss="modal" [disabled]="startDate == null || disabledBtn || productInfo.priceValue =='' || productInfo.priceValue == 0 || productInfo.priceValue < productInfo.minPrice"> -->
            <button class="btn btn-block btn-primary btn-lg" type="submit" (click)="submitBid()">
                {{ 'home.productHeader.ConfirmBid' | cxTranslate }}
            </button>
            <div class="d-flex justify-content-between mt-2">
                <button class="btn btn-light btn-lg button" type="button" (click)="backToPlacebid()">{{'tenders.Back'|
                    cxTranslate}}</button>
                <button class="btn btn-light btn-lg button" type="button" (click)="activeModal.dismiss('close click')"
                    data-dismiss="modal">{{ 'home.productHeader.Close' | cxTranslate }}</button>
            </div>
        </div>
    </div>
</div>